import {combineReducers} from 'redux'
import {
    sessionReducer
} from 'redux-react-session'
const param = (state = {}, action) => {
    return {...state, [action.type]: action.value}
}

const Reducers = combineReducers({param, session: sessionReducer})
export default Reducers